import React from 'react'
import PropTypes from 'prop-types'
import { Pane, Image, minorScale, majorScale } from 'evergreen-ui'

const SearchResultImage = ({ url }) => (
  <Pane
    width={minorScale(7)}
    height={minorScale(7)}
    display="flex"
    alignItems="center"
    justifyContent="center"
    marginRight={majorScale(1)}
  >
    <Image maxHeight={majorScale(3)} maxWidth={majorScale(3)} src={url} />
  </Pane>
)

SearchResultImage.propTypes = {
  url: PropTypes.string.isRequired
}

export default SearchResultImage
